import { z } from 'zod';

export const customFieldSchema = z.object({
  name: z.string().min(1, 'Field name is required').max(255, 'Field name is too long'),
  field_type: z.enum(['text', 'number', 'date', 'dropdown', 'textarea', 'checkbox'], {
    required_error: 'Field type is required',
  }),
  options: z.string().optional(),
  is_required: z.boolean(),
  default_value: z.string().optional(),
  display_order: z.number().int().min(0),
  is_active: z.boolean(),
  // Category restriction - empty array means applies to ALL categories
  limit_to_categories: z.boolean(),
  category_ids: z.array(z.string()).optional(),
});

export type CustomFieldFormValues = z.infer<typeof customFieldSchema>;
